import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { retrieveTokens } from 'amazon-cognito-passwordless-auth/storage';

// console.log('Base URL:', process.env.NEXT_PUBLIC_API_URL);

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.NEXT_PUBLIC_ADMIN_API_BASE_URL,
  prepareHeaders: async (headers) => {
    //const { accessToken } = (await fetchAuthSession()).tokens ?? {};
    const { accessToken } = (await retrieveTokens()) ?? {};
    headers.set('Authorization', `Bearer ${accessToken?.toString()}`);
    headers.set('Content-Type', 'application/json');
    return headers;
  },
});
